import { produce } from 'immer';
import { create, SetState } from 'zustand';
import {
  SelectModalAction,
  SelectModalStore,
  useSelectModalState,
} from '~/types';

const initialSelectModalState = (): useSelectModalState => ({
  modalTitle: '',
  selectedOption: '',
  isOpen: false,
  selectOptions: [],
  click: (option: string) => {
    console.log(`Option clicked: ${option}`);
  },
});

const SelectModalActions = (
  set: SetState<SelectModalStore>,
): SelectModalAction => ({
  setModalState: (newState: useSelectModalState) =>
    set(
      produce((state) => {
        state.modalTitle = newState.modalTitle;
        state.selectedOption = newState.selectedOption;
        state.isOpen = newState.isOpen;
        state.selectOptions = newState.selectOptions;
        state.click = newState.click;
      }),
    ),
});

const useSelectModalStore = create<SelectModalStore>((set) => ({
  ...initialSelectModalState(),
  ...SelectModalActions(set),
}));

export default useSelectModalStore;
